import { Capacitor } from "@capacitor/core";

/**
 * In the native shell, page-level pinch/double-tap zoom (and iOS's zoom-on-input-focus)
 * reads as a website, not an app — native screens never zoom their chrome. Pin the
 * viewport scale there. Browsers keep the default zoomable viewport (accessibility);
 * in-content zoom surfaces (FileViewer, overlay viewers, ImageLightbox) implement
 * their own pinch handling and are unaffected.
 */
export function configureNativeViewport(): void {
    if (!Capacitor.isNativePlatform()) {
        return;
    }
    document
        .querySelector('meta[name="viewport"]')
        ?.setAttribute(
            "content",
            "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover",
        );
}
